import { module } from "angular";
import { map } from "rxjs/operators";

import type { Observable } from "rxjs";

import type { IHttpService } from "App/Modules/Services";

import type { IResponse } from "App/Modules/Models";

import type { IPartnerUserRolesAndLabels } from "App/Modules/Models/Models/IPartnerUserRolesAndLabels";
import { SitesRepository } from "../Site/SitesRepository";

import type { IUsersRepository } from "./IUsersRepository";

export class UsersRepository implements IUsersRepository {
    public static $inject: string[] = ["mmHttpService"];

    private static enhancePartnerUserRolesAndLabels(users: IPartnerUserRolesAndLabels[]) {
        users.forEach((user) => {
            user.sites = [];

            user.teamMemberships.forEach((membership) => {
                membership.team.sites.forEach((site) => {
                    SitesRepository.enhanceSite(site);

                    user.sites.push({
                        ...site,
                        labels: membership.labels,
                        role: membership.role,
                        team: membership.team,
                    });
                });
            });
        });
    }

    constructor(private readonly httpService: IHttpService) {}

    public getUsers(code: string): Observable<IResponse<IPartnerUserRolesAndLabels[]>> {
        return this.httpService.get<IPartnerUserRolesAndLabels[]>(`users/byCode/${code}`).pipe(
            map((response) => {
                UsersRepository.enhancePartnerUserRolesAndLabels(response.data);
                return response;
            }),
        );
    }
}

module("mmRepositories").service("irUsersRepository", UsersRepository);
